<template>
  <footer class="main-footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3>Contact Us</h3>
        <p>WhatsApp: <a href="https://wa.me/966500000000" target="_blank">+201118696626</a></p>
        <p>Phone: <a href="tel:01118696626">+201118696626</a></p>
        <p>Email: <a href="mailto:info@academy-robotics.com">info@robotoschool.com</a></p>
      </div>
      <div class="footer-section">
        <h3>Page Links</h3>
        <ul class="footer-links">
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/about">About Us</router-link></li>
          <li><router-link to="/vision">Our Vision</router-link></li>
          <li><router-link to="/programs">Programs</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </div>
      <div class="footer-section">
        <h3>Branches</h3>
        <p><strong>Address 1:</strong> Sheikh Zayed, Villa 227, District 8, Block 3, in front of Plaza Espana.</p>
        <p><strong>Address 2:</strong> Tanta, Hassan Radwan Street, Zahret Al-Radwan Tower, First Floor.</p>
      </div>
    </div>
    <div class="footer-bottom">
      All rights reserved © Kids Robotics Academy 2025
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter',
};
</script>

<style scoped>
.main-footer {
  background: #222;
  color: #fff;
  padding: 2.5rem 1rem 1rem 1rem;
  margin-top: 60px;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  max-width: 1100px;
  margin: 0 auto;
  flex-wrap: wrap;
}
.footer-section {
  flex: 1;
  min-width: 220px;
  margin-bottom: 1.5rem;
}
.footer-section h3 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: #ffd600;
}
.footer-section p, .footer-section a {
  font-size: 1rem;
  color: #fff;
  margin-bottom: 0.5rem;
  text-decoration: none;
}
.footer-links {
  list-style: none;
  padding: 0;
}
.footer-links li {
  margin-bottom: 0.5rem;
}
.footer-links a {
  color: #90caf9;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-links a:hover {
  color: #ffd600;
}
.footer-bottom {
  text-align: center;
  padding-top: 1rem;
  font-size: 0.95rem;
  color: #bbb;
  border-top: 1px solid #444;
}
@media (max-width: 900px) {
  .footer-content {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }
  .footer-section {
    min-width: unset;
    text-align: center;
  }
}
</style>
